import { render, staticRenderFns } from "./CommentPreview.vue?vue&type=template&id=1daea97f&scoped=true&"
import script from "./CommentPreview.vue?vue&type=script&lang=js&"
export * from "./CommentPreview.vue?vue&type=script&lang=js&"
import style0 from "./CommentPreview.vue?vue&type=style&index=0&id=1daea97f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daea97f",
  null
  
)

export default component.exports